import { AppConfigImpl } from 'aos-services/src/services/config/types/AppConfig'
import { ExternalConfig } from 'aos-services/src/services/config/types/ExternalConfig'

const mfInfo = typeof MF_APPS_INFO !== 'undefined' ? MF_APPS_INFO : undefined
const version = typeof APP_VERSION !== 'undefined' ? APP_VERSION : GIT_TAG

const externalConfig: ExternalConfig = {
    environmentName: process.env.ENVIRONMENT_NAME || '',
    originUrl: process.env.ORIGIN_URL || '',
    corsProxyUrl: process.env.CORS_PROXY_URL || '',
    apiUrl: process.env.API_URL || '',
    mapUrl: process.env.MAP_URL || '',
    androidAppUrl: process.env.ANDROID_APP_URL || '',
    iosAppUrl: process.env.IOS_APP_URL || '',
    sentryUrl: process.env.SENTRY_DSN || '',
    logging: process.env.LOGGING === 'true',
    firebase: {
        apiKey: process.env.FIREBASE_API_KEY || '',
        authDomain: process.env.FIREBASE_AUTH_DOMAIN || '',
        databaseURL: process.env.FIREBASE_DATABASE_URL || '',
        projectId: process.env.FIREBASE_PROJECT_ID || '',
        storageBucket: process.env.FIREBASE_STORAGE_BUCKET || '',
        messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID || '',
        appId: process.env.FIREBASE_APP_ID || '',
        measurementId: process.env.FIREBASE_MEASUREMENT_ID || '',
    },
    analyticsKey: process.env.ANALYTICS_KEY || '',
    keycloakConfig: {
        realm: process.env.KEYCLOAK_REALM || '',
        url: process.env.KEYCLOAK_URL || '',
        clientId: process.env.KEYCLOAK_CLIENT_ID || '',
        returnUrl: process.env.KEYCLOAK_RETURN_URL || '',
    },
    theme: process.env.APP_THEME || '',
    name: process.env.APP_DISPLAY_NAME || '',
    flightTableAppUrl: process.env.FLIGHT_TABLE_APP_URL || '',
    kanbanAppUrl: process.env.KANBAN_APP_URL || '',
    taskTemplatesAppUrl: process.env.TASK_TEMPLATES_APP_URL || '',
}

export const appConfig = new AppConfigImpl(externalConfig, GIT_HASH, GIT_REF, version, mfInfo)
